import React, { useState, useEffect } from 'react';
import {Row, Col } from 'react-bootstrap';
import { toast, ToastContainer } from "react-toastify";

import { useNavigate, Link} from "react-router-dom";
import axios from 'axios';
import DatePicker from 'react-datepicker';
import { format } from 'date-fns';
import { PieChart, Pie, Sector, ResponsiveContainer } from 'recharts';

import category1Icon from '../../dist/images/icons/categories/1.png'
import category2Icon from '../../dist/images/icons/categories/2.png'
import category3Icon from '../../dist/images/icons/categories/3.png'
import category4Icon from '../../dist/images/icons/categories/4.png'
import category5Icon from '../../dist/images/icons/categories/5.png'
import category6Icon from '../../dist/images/icons/categories/6.png'
import category7Icon from '../../dist/images/icons/categories/7.png'
import category8Icon from '../../dist/images/icons/categories/8.png'
import category9Icon from '../../dist/images/icons/categories/9.png'

import AddRecords from "./../Records/AddRecords";

import checkedIcon from '../../dist/images/icons/checked.png';
import expensesIcon from '../../dist/images/icons/expenses-grn.png'
import incomeIcon from '../../dist/images/icons/income-grn.png'
import editIcon from '../../dist/images/icons/edit.png'
import deleteIcon from '../../dist/images/icons/delete.png'
import rightIcon from '../../dist/images/icons/right.png'

// const chartData = [
//   { name: 'Group A', value: 400 },
//   { name: 'Group B', value: 300 },
//   { name: 'Group C', value: 300 },
//   { name: 'Group D', value: 200 },
// ];


const renderActiveShape = (props) => {
  const RADIAN = Math.PI / 180;
  const { cx, cy, midAngle, innerRadius, outerRadius, startAngle, endAngle, fill, payload, percent, value } = props;
  const sin = Math.sin(-RADIAN * midAngle);
  const cos = Math.cos(-RADIAN * midAngle);
  const sx = cx + (outerRadius + 10) * cos;
  const sy = cy + (outerRadius + 10) * sin;
  const mx = cx + (outerRadius + 30) * cos;
  const my = cy + (outerRadius + 30) * sin;
  const ex = mx + (cos >= 0 ? 1 : -1) * 22;
  const ey = my;
  const textAnchor = cos >= 0 ? 'start' : 'end';

  return (
    <g>
      <text x={cx} y={cy} dy={8} textAnchor="middle" fill={fill}>
        {payload.name}
      </text>
      <Sector
        cx={cx}
        cy={cy}
        innerRadius={innerRadius}
        outerRadius={outerRadius}
        startAngle={startAngle}
        endAngle={endAngle}
        fill={fill}
      />
      <Sector
        cx={cx}
        cy={cy}
        startAngle={startAngle}
        endAngle={endAngle}
        innerRadius={outerRadius + 6}
        outerRadius={outerRadius + 10}
        fill={fill}
      />
      <path d={`M${sx},${sy}L${mx},${my}L${ex},${ey}`} stroke={fill} fill="none" />
      <circle cx={ex} cy={ey} r={2} fill={fill} stroke="none" />
      <text x={ex + (cos >= 0 ? 1 : -1) * 12} y={ey} textAnchor={textAnchor} fill="#333">{`Inr ${value}`}</text>
      <text x={ex + (cos >= 0 ? 1 : -1) * 12} y={ey} dy={18} textAnchor={textAnchor} fill="#999">
        {`(Rate ${(percent * 100).toFixed(2)}%)`}
      </text>
    </g>
  );
};

const Records = ({ user, onLogout }) => {
  const apiUrl = process.env.REACT_APP_API_URL;
  // useEffect(() => {
  //   const timer = setTimeout(() => {
  //     alert('Session expired. Logging out.');
  //     onLogout();
  //   }, 60000); // 1 minute session timeout

  //   return () => clearTimeout(timer);
  // }, [onLogout]);

  const [recordData, setRecordData] = useState([])
  const [categoryData, setCategoryData] = useState([])
  const [activeData, setActiveData] = useState(null)
  const [recentData, setRecentData] = useState([])
  const [filteredData, setFilteredData] = useState([]);
  const [categoryTotals, setCategoryTotals] = useState({});

  const [chartData, setChartData] = useState(
    )

  const navigate = useNavigate();

  const categoryIcons = {
  1: category1Icon,
  2: category2Icon,
  3: category3Icon,
  4: category4Icon,
  5: category5Icon,
  6: category6Icon,
  7: category7Icon,
  8: category8Icon,
  9: category9Icon,
};

const [activeIndex, setActiveIndex] = useState(0);

  const onPieEnter = (_, index) => {
    setActiveIndex(index);
  };


  const fetchData = () => {
    axios.get(`${apiUrl}Records`)
          .then(response => {
            setRecordData(response.data);
            const dataLength = response.data.length
            setActiveData(response.data[dataLength - 1].id)
          })
          .catch(error => {
            console.error('Error fetching data: ', error);
          });
  }
  const fetchCategoryOptions = () => {
    axios.get(`${apiUrl}Category`)
          .then(response => {
            setCategoryData(response.data);
          })
          .catch(error => {
            console.error('Error fetching data: ', error);
          });
  }

  useEffect(()=> {
    if(categoryData && recordData) {
      setCategoryTotals(calculateTotalByCategory());
    }
  }, [recordData, categoryData])

  //const recentData = recordData?.slice(0, 7);

  useEffect(()=> {
    fetchData()
    fetchCategoryOptions()
  }, [])


  useEffect(() => {
    if (categoryTotals && Object.keys(categoryTotals)?.length > 0) {
      // Convert categoryTotals to chartData format
      const chartDataArray = Object.entries(categoryTotals).map(([key, value]) => ({
        name: categoryData?.find(data => parseInt(data.id) === parseInt(key))?.Category,
        value: value
      }));
      setChartData(chartDataArray);
    }
  }, [categoryTotals, recordData, categoryData]);


  

  const getCurrentMonthData = (data) => {
    const currentMonth = new Date().getMonth(); // 0-11 for months
    const currentYear = new Date().getFullYear();

    return data.filter(item => {
      const itemDate = new Date(item.date);
      return itemDate.getMonth() === currentMonth && itemDate.getFullYear() === currentYear;
    });
  };
  useEffect(()=> {
    const sortedData = recordData.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
    const last7 = sortedData.slice(0, 7);
    setRecentData(last7);
    setFilteredData(getCurrentMonthData(recordData))
    
  }, [recordData])

  useEffect(()=> {
    console.log("recentData", recentData, recordData, filteredData, categoryTotals)
  }, [recentData, recordData, filteredData, categoryTotals])


  const handleRecordPageChange = () => {
    navigate('/records/')
  }

  const handleCreateRecordsChange = () => {
    navigate('/dashboard/records/create/')
  }

  const handleActiveDataChange = (id) => {
    setActiveData(id)
  }

  const calculateTotal = (categoryType) => {
    return filteredData
      .filter(item => parseInt(item.categoryType) === categoryType)
      .reduce((total, item) => total + parseFloat(item.amount), 0);
  };

  const calculateTotalByCategory = () => {
    return filteredData.reduce((totals, item) => {
      const category = item.category;
      const amount = parseFloat(item.amount);

      if (!totals[category]) {
        totals[category] = 0;
      }

      totals[category] += amount;
      return totals;
    }, {});
  };

  return (
    <div>
    <Row>
      <Col md="6">
        <h1 className="main-heading-one">Hi, <span className="mark">{user}!</span>
        <br/>What are your planes for today!</h1>
        <p className="main-paragraph"><img src={checkedIcon} /> Use this platform to record and manage your expenses and income.</p>
        <p className="main-paragraph"><img src={checkedIcon} /> Gain insights into your monthly or weekly financial activities to help improve your financial management.</p>
        
        <p className="main-paragraph"><img src={checkedIcon} /> Start tracking today to better understand your spending patterns and take control of your finances.</p>
        

        <button className="btn-lgt-green  me-3 mb-3" 
        onClick={handleRecordPageChange}
        >
          View Records
        </button>
        <button className="btn-green" 
        onClick={handleCreateRecordsChange}
        >
          Create Your Financial Journey
        </button>
      </Col>
      <Col md="6" className="p-5">
      <Row>
        <Col md="6">
          <div className="data-grid p-4">
                <Row>
                  <Col md="auto">
                    <img src={expensesIcon} />
                  </Col>
                  <Col>
                  <h4 class="main-title pt-2 cl-red">Rs. {calculateTotal(1)} </h4>
                  Expense - <span className="fw-bold"> {filteredData?.length > 0 && format(filteredData[0].date, 'MMMM')} </span>
                  </Col>
                </Row>
          
             
          </div>
        </Col>
        <Col md="6">
          <div className="data-grid p-4">
                <Row>
                  <Col md="auto">
                    <img src={incomeIcon} />
                  </Col>
                  <Col>
                  <h4 class="main-title pt-2 cl-green">Rs. {calculateTotal(2)} </h4>
                  Income - <span className="fw-bold "> {filteredData?.length > 0 && format(filteredData[0].date, 'MMMM')} </span>
                  </Col>
                </Row>
          
             
          </div>
        </Col>
      </Row>
      <div className="data-grid p-4 mt-5">
                <Row>

                  <Col>
                  <h4 class="main-title pt-2">Email Month Report </h4>
                  Receive a summary of all your expense and income records every <span className="fw-bold mark">7th</span> of the month directly to your email.
                  </Col>
                </Row>
          
             
          </div>

      </Col>

    </Row>

    <Row>
    <Col md="5" className="p-3 data-grid-02 mt-5">
      <h4>Latest Records </h4>
          <div className="record-wrapper">
              <div className="date-filter">
              <ul type="none">
                {recentData?.map((data) => (
                  <li  key={data.id} 
                  onClick={() =>handleActiveDataChange(data.id)}
                  className={parseInt(activeData) === parseInt(data.id) ? 'active cursor-pointer' : 'cursor-pointer' } >
                    {format(data.date, 'MMM')} <br/> <span>{format(data.date, 'd')}</span>
                  </li>
                  ))}


                
              </ul>
              </div>

              <div className="record-details">
              {recentData?.filter(data => parseInt(data.id) === parseInt(activeData))?.map(data => (
                <div key={data.id} className="">
                  <p className="date-data my-3">
                  <span>{new Date(data.date).toLocaleDateString()}</span>
                  </p>
                  <div className="date-data-inner my-4">
                    <div className="date-data-img">
                    <img src={categoryIcons[data.category]} width="30"/>
                    </div>
                    <div className="date-data-content ps-3" style={{width: "85%"}}>
                    <p className="mb-0 fw-bold">{data.name}</p>
                    <p className="mb-0" style={{color: "#6e6e6e"}}><span>{`${data.categoryType === '1' ? 'Expense' : 'Income'}`} :  </span><span>{data.amount}</span></p>
                    </div>
                    <div className="date-data-nav">
                    <Link to="/records/"><img src={rightIcon} width="30"/></Link>
                    </div>
                  </div>
                </div>
              ))}
              </div>

          </div>

      </Col>

      <Col md="7" className="p-3 data-grid-02 mt-5">
      <h4>Current Month Status</h4>
          <div className="chart-wrapper"  >
          <div className="chart-inner"  >
                 <ResponsiveContainer width="100%" height="100%">
                  <PieChart width={400} height={400}>
                    <Pie
                      activeIndex={activeIndex}
                      activeShape={renderActiveShape}
                      data={chartData}
                      cx="50%" // Horizontal center
                      cy="50%" // Vertical center
                      innerRadius={60} // Inner radius
                      outerRadius={80} // Outer radius
                      fill="#ad8554" // Default fill color
                      dataKey="value" // Data key to use for values
                      onMouseEnter={onPieEnter} // Event handler for mouse hover
                    />
                  </PieChart>
                </ResponsiveContainer>
          
             </div>

             <div className="chart-data"  >
                <div className=""  >
                {chartData?.length > 0 && 
                      chartData?.map((data, index) => (
                  <p key={index}>
                    {data.name}: <span className="fw-bold">{data.value}</span>
                  </p>
                ))}
                  
                </div>
             </div>

          </div>

      </Col>
     
    </Row>



    <AddRecords />
    <ToastContainer autoClose={1500} />

    </div>
  );
};




export default Records;